import { SocialAuthProvider } from "api/resources/auth/types"
import {
  AI_TOOLS_FIREBASE_KEY,
  getFeatureToggleConfig,
  PLATFORM_ONBOARDING_FIREBASE_KEY,
  PROFILE_STRENGTH_FIREBASE_KEY,
  SOCIAL_AUTH_FIREBASE_KEY,
} from "firebaseInit"
import posthog from "posthog-js"

import { ValueOfEnum } from "./types"

const LOCAL_CACHE_KEY = "featureToggleManagerCache"

export type FeatureToggleType = {
  socialAuth: {
    isEnabled: boolean
    providers: ValueOfEnum<SocialAuthProvider>[]
  }
  aiTools: {
    inactiveTools?: string[]
    isEnabled: boolean
  }
  platformOnboarding: {
    isEnabled: boolean
  }
  profileStrength: {
    isEnabled: boolean
  }
  posthogFlags: Record<string, never>
}

export const featureToggleDefaultValues: FeatureToggleType = {
  socialAuth: {
    isEnabled: false,
    providers: [],
  },
  aiTools: {
    inactiveTools: [],
    isEnabled: true,
  },
  platformOnboarding: {
    isEnabled: true,
  },
  profileStrength: {
    isEnabled: true,
  },
  posthogFlags: {},
}

export const FeatureToggleManager = {
  socialAuth: featureToggleDefaultValues.socialAuth,
  aiTools: featureToggleDefaultValues.aiTools,
  platformOnboarding: featureToggleDefaultValues.platformOnboarding,
  profileStrength: featureToggleDefaultValues.profileStrength,
  posthogFlags: featureToggleDefaultValues.posthogFlags,

  updateCache() {
    const data = JSON.stringify({
      socialAuth: this.socialAuth,
      aiTools: this.aiTools,
      platformOnboarding: this.platformOnboarding,
      profileStrength: this.profileStrength,
      posthogFlags: this.posthogFlags,
    })
    localStorage.setItem(LOCAL_CACHE_KEY, data)
  },
  getConfig() {
    return {
      socialAuth: this.socialAuth,
      aiTools: this.aiTools,
      platformOnboarding: this.platformOnboarding,
      profileStrength: this.profileStrength,
      posthogFlags: this.posthogFlags,
    }
  },

  init() {
    try {
      const data: {
        [x: string]: any
      } = JSON.parse(localStorage.getItem(LOCAL_CACHE_KEY) as string)

      Object.entries(data).forEach(([key, value]) => {
        if (
          [
            "socialAuth",
            "aiTools",
            "platformOnboarding",
            "profileStrength",
            "posthogFlags",
          ].includes(key)
        ) {
          this[key] = value
        }
      })
      return this
    } catch (_) {
      return this
    }
  },
  async syncFromFirebase() {
    const data = await getFeatureToggleConfig()

    const socialAuthData = data[SOCIAL_AUTH_FIREBASE_KEY]
    const aiToolsData = data[AI_TOOLS_FIREBASE_KEY]
    const platformOnboardingData = data[PLATFORM_ONBOARDING_FIREBASE_KEY]
    const profileStrengthData = data[PROFILE_STRENGTH_FIREBASE_KEY]

    if (socialAuthData) {
      this.socialAuth.isEnabled =
        socialAuthData.enabled.web && socialAuthData.providers.length > 0
      this.socialAuth.providers = socialAuthData.providers
    }

    if (aiToolsData) {
      this.aiTools.isEnabled = aiToolsData.enabled.web
      this.aiTools.inactiveTools = aiToolsData.inactiveTools
    }

    if (platformOnboardingData) {
      this.platformOnboarding.isEnabled = platformOnboardingData.enabled.web
    }

    if (profileStrengthData) {
      this.profileStrength.isEnabled = profileStrengthData.enabled.web
    }

    this.updateCache()
    return this
  },

  // async syncFromPosthog() {
  //   posthog.reloadFeatureFlags()

  //   this.updateCache()
  //   return this
  // },
}
